<template>
  <div>
    <px-view-header title="Pedido de compra" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" link @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading />
    </div>
    <div v-if="!loading && venda">
      <px-venda-conjunta-details :venda="venda" @movimentar="onUpdate" />
      <px-venda-conjunta-vendas class="mt-3" :venda="venda" @update="onUpdate"/>
    </div>
  </div>
</template>

<script>
import VendaConjuntaService from './venda-conjunta-service';
import VendaConjuntaDetails from './VendaConjuntaDetails.vue';
import VendaConjuntaVendas from './VendaConjuntaVendas.vue';

export default {
  data() {
    return {
      id: this.$route.params.id,
      venda: null,
      loading: false,
      breadcrumbs: [
        { text: 'Negócios' },
        { text: 'Vendas' },
        { text: 'Pedido de compra' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
    onUpdate() {
      this.getVenda();
    },
    getVenda() {
      this.loading = true;
      VendaConjuntaService.getVenda(this.id)
        .then(({ data }) => {
          this.venda = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getVenda();
  },
  components: {
    pxVendaConjuntaDetails: VendaConjuntaDetails,
    pxVendaConjuntaVendas: VendaConjuntaVendas,
  },
};
</script>
